import { graphql } from "gatsby";
import React from "react";
import {
  HomeWidgetCategoryFragment,
  HomeWidgetFragment,
} from "../../../../graphql-types";
import Image from "../../../components/GatsbyImage";
import { CategoryCard } from "./CategoryCard";

type Props = {
  categories: HomeWidgetCategoryFragment[];
  widget: HomeWidgetFragment;
};

export default function HomeWidget({ categories, widget }: Props) {
  const { headingImage, strapline } = widget;
  return (
    <section className="max-w-container mx-auto text-center mb-14">
      <Image
        alt={headingImage.description || ""}
        className="max-w-md my-10"
        image={headingImage.gatsbyImageData}
      />
      <p className="mx-4 mb-12 text-lg font-semibold font-montserrat">
        {strapline}
      </p>
      <div className="mx-2 grid lg:grid-cols-3">
        {categories.map(({ id, ...category }) => (
          <CategoryCard key={id} category={category} />
        ))}
      </div>
    </section>
  );
}

export const fragments = {
  categories: graphql`
    fragment HomeWidgetCategory on SustainabilityCategory {
      id
      ...CategoryCardCategory
    }
  `,
  widget: graphql`
    fragment HomeWidget on SustainabilityWidget {
      strapline
      headingImage {
        description
        gatsbyImageData(height: 500, layout: CONSTRAINED)
      }
    }
  `,
};
